import { render, staticRenderFns } from "./fs-pill-status.vue?vue&type=template&id=782ed751&scoped=true"
import script from "./fs-pill-status.vue?vue&type=script&lang=js"
export * from "./fs-pill-status.vue?vue&type=script&lang=js"
import style0 from "./fs-pill-status.vue?vue&type=style&index=0&id=782ed751&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782ed751",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782ed751')) {
      api.createRecord('782ed751', component.options)
    } else {
      api.reload('782ed751', component.options)
    }
    module.hot.accept("./fs-pill-status.vue?vue&type=template&id=782ed751&scoped=true", function () {
      api.rerender('782ed751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/pills/fs-pill-status.vue"
export default component.exports